import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { KEY_VALUE_TYPE } from '@/types';

interface DropdownInputProps<T> {
  value: T;
  isLoading: boolean;
  options: KEY_VALUE_TYPE<T>;
  onChange: (v: T) => void;
}
const DropdownInput = <T,>({ value, isLoading, onChange, options }: DropdownInputProps<T>) => {
  return (
    <div>
      <select
        className="rounded border hover:cursor-pointer"
        onChange={(e) => onChange(e.target.value as T)}
        value={String(value)}
      >
        {Object.values(options).map((option) => (
          <option key={option.label} value={String(option.value)}>
            {option.label}
          </option>
        ))}
      </select>
      {isLoading && <FontAwesomeIcon icon={faCircleNotch} className="h-6 w-6 animate-spin text-gray-500" />}
    </div>
  );
};

export default DropdownInput;
